import axios from 'axios';
import { getHubApiUrl, getHubAuthHeaders } from '../utils/hubApi';

const HUB_API_URL = getHubApiUrl();

/**
 * Fetches the real-time invoice URL for a specific company from the Hub API backend.
 *
 * @param {string|number} companyId - The production company ID of the logged-in user.
 * @param {object|string} credencials - The user credentials object or sessionToken.
 * @returns {Promise<string|null>} The invoice URL or null if not found.
 */
export async function getInvoiceUrlForCompany(companyId, credencials) {
    if (!companyId) return null;

    const credsObj = typeof credencials === 'object'
        ? credencials
        : { sessionToken: credencials, company: companyId };

    const headers = await getHubAuthHeaders(credsObj);

    try {
        let url = `${HUB_API_URL}/subscriptions/invoice-url?company_id=${companyId}`;
        let response;

        try {
            response = await axios.get(url, { headers });
        } catch (err) {
            // Fallback for local dev if HUB_API_URL is unreachable locally
            if (process.env.NODE_ENV === 'development') {
                const devUrl = `http://localhost:8000/subscriptions/invoice-url?company_id=${companyId}`;
                response = await axios.get(devUrl, { headers });
            } else {
                throw err;
            }
        }

        if (response && response.data && response.data.invoiceUrl) {
            return response.data.invoiceUrl;
        }
        return null;
    } catch (error) {
        console.error('[getInvoiceUrlForCompany] Error fetching invoice URL from Hub API:', error);
        return null;
    }
}
